"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class CalculatorResult extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'calculatorResult';
        this._inboundId = initParams.inbound_id;
        this._totalSavingData = initParams.total_saving_data;
        this._applianceSavingData = (0, util_1.camelArray)(initParams.appliance_saving_data);
        this._hours = (0, util_1.camelArray)(initParams.hours);
        this._appliances = (0, util_1.camelArray)(initParams.appliances);
        this._receivedSavingEmail = initParams.received_saving_email;
    }
    set inboundId(value) {
        console.error('Do not set objects this way');
    }
    get inboundId() {
        return this._inboundId;
    }
    set totalSavingData(value) {
        console.error('Do not set objects this way');
    }
    get totalSavingData() {
        return this._totalSavingData;
    }
    set applianceSavingData(value) {
        console.error('Do not set objects this way');
    }
    get applianceSavingData() {
        return this._applianceSavingData;
    }
    set hours(value) {
        console.error('Do not set objects this way');
    }
    get hours() {
        return this._hours;
    }
    set appliances(value) {
        console.error('Do not set objects this way');
    }
    get appliances() {
        return this._appliances;
    }
    set receivedSavingEmail(value) {
        console.error('Do not set objects this way');
    }
    get receivedSavingEmail() {
        return this._receivedSavingEmail;
    }
}
exports.default = CalculatorResult;
//# sourceMappingURL=calculatorResult.js.map